import IconComponent from "icons/IconComponent";

import BackIcon from "./back.svg";

export default (BackIcon as any) as IconComponent;
